export default (product) => product && product.soldOutOnline;
